import React, { useState, useRef } from "react";
import { Box, Popover, Typography } from "@mui/material";
import { SketchPicker } from "react-color";

interface ColorPickerFieldProps {
  label: string;
  color: string;
  onChange: (color: string) => void;
}

export const ColorPickerField: React.FC<ColorPickerFieldProps> = ({ label, color, onChange }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
        {label}
      </Typography>
      <Box
        onClick={handleClick}
        sx={{
          cursor: "pointer",
          width: 40,
          height: 40,
          borderRadius: 1,
          border: "1px solid #ccc",
          backgroundColor: color,
        }}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <SketchPicker
          color={color}
          onChangeComplete={(c) => onChange(c.hex)}
          disableAlpha
        />
      </Popover>
    </Box>
  );
};
